import HomePage from './HomePage';

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage/index.js